import styled from "styled-components"

const Adjective = styled.span`
  font-size: var(--font-sub);
  line-height: var(--line-sub);
  font-weight: bold;
  text-transform: uppercase;
  color: var(--gray-text);
  opacity: 0.8;
  user-select: none;
`

export default Adjective